import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Tools() {
  return <ImageCollectionPage title="Tools" path="/culture/tools" collection="culture_tools" />;
}
